import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import installerService from "./installerService";

const initialState = {
    installer: null,
    adders: [],
    docs: [],
    license: [],
    single_license: [],
    isError: false,
    isSuccess: false,
    isLodaing: false,
    errors: [],
    massage: "",
};

export const getAllInstaller = createAsyncThunk(
    "installer/get",
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await installerService.getAllInstaller(token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const installerSearchAction = createAsyncThunk(
    "installer/search",
    async (data, thunkAPI) => {
        try {
            return await installerService.installerSearch(data);
        } catch (error) {
            const message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const UpdateInstaller = createAsyncThunk(
    "installer/update",
    async (data, thunkAPI) => {
        try {
            return await installerService.UpdateInstaller(data);
        } catch (error) {
            const message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const RegisterFormInstaller = createAsyncThunk(
    "installer/register",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await installerService.RegisterFormInstaller(data, token);
        } catch (error) {
            return rejectWithValue(error.response.data.errors);
        }
    }
);

export const BussinessLicenceInstaller = createAsyncThunk(
    "installer/buss_licence/create",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await installerService.BussinessLicenceInstaller(
                data,
                token
            );
        } catch (error) {
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const BussinessLicenceInstallerUpdate = createAsyncThunk(
    "installer/buss_licence/update",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await installerService.BussinessLicenceInstallerUpdate(
                data,
                token
            );
        } catch (error) {
            return rejectWithValue(error.response.data.error);
        }
    }
);
export const WorkingDaysInstaller = createAsyncThunk(
    "installer/working_days",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await installerService.WorkingDaysInstaller(data, token);
        } catch (error) {
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const AdderRateInstaller = createAsyncThunk(
    "installer/adders_rate",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await installerService.AdderRateInstaller(data, token);
        } catch (error) {
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const GetInstallerDocs = createAsyncThunk(
    "installer/docs",
    async (installer_id, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await installerService.GetInstallerDocs(installer_id);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);

export const GetInstallerAdders = createAsyncThunk(
    "installer/adders",
    async (installer_id, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await installerService.GetInstallerAdders(installer_id);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);

export const GetInstallerLicense = createAsyncThunk(
    "installer/license",
    async (installer_id, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await installerService.GetInstallerLicense(installer_id);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);
export const InstallerLicenseCreate = createAsyncThunk(
    "installer/license/create",
    async (data, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await installerService.InstallerLicenseCreate(data);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);
export const InstallerLicenseEdit = createAsyncThunk(
    "installer/license/update",
    async (data, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await installerService.InstallerLicenseEdit(data);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);

export const GetSingleInstaller = createAsyncThunk(
    "installer/show",
    async (installer_id, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await installerService.GetSingleInstaller(installer_id);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);
export const GetSingleInstallerLicense = createAsyncThunk(
    "installer/license/show",
    async (license_id, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await installerService.GetSingleInstallerLicense(license_id);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);
export const DeleteSingleInstaller = createAsyncThunk(
    "installer/delete",
    async (license_id, thunkAPI) => {
        let { rejectWithValue } = thunkAPI;
        try {
            return await installerService.DeleteSingleInstaller(license_id);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);



const installerSlice = createSlice({
    name: "installer",
    initialState,
    reducers: {
        reset: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isLodaing = false;
            state.massage = "";
        },
    },

    extraReducers: {
        //getAllInstaller Actions
        [getAllInstaller.pending]: (state) => {
            state.isLodaing = true;
        },
        [getAllInstaller.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.installer = action.payload;
            state.isSuccess = true;
        },
        [getAllInstaller.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        //installerSearchAction Actions
        [installerSearchAction.pending]: (state) => {
            state.isLodaing = true;
        },
        [installerSearchAction.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.installer = action.payload;
            state.isSuccess = true;
        },
        [installerSearchAction.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        //UpdateInstaller Actions
        [UpdateInstaller.pending]: (state) => {
            state.isLodaing = true;
        },
        [UpdateInstaller.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [UpdateInstaller.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },
        //Register New Installer Actions
        [RegisterFormInstaller.pending]: (state) => {
            state.isLodaing = true;
        },
        [RegisterFormInstaller.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [RegisterFormInstaller.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        //Bussiness Licence  Installer Actions
        [BussinessLicenceInstaller.pending]: (state) => {
            state.isLodaing = true;
        },
        [BussinessLicenceInstaller.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [BussinessLicenceInstaller.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },


        //Bussiness Licence  Installer Actions
        [BussinessLicenceInstallerUpdate.pending]: (state) => {
            state.isLodaing = true;
        },
        [BussinessLicenceInstallerUpdate.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [BussinessLicenceInstallerUpdate.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },
        //Working Days Installer Actions
        [WorkingDaysInstaller.pending]: (state) => {
            state.isLodaing = true;
        },
        [WorkingDaysInstaller.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [WorkingDaysInstaller.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        //Working Days Installer Actions
        [AdderRateInstaller.pending]: (state) => {
            state.isLodaing = true;
        },
        [AdderRateInstaller.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [AdderRateInstaller.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Installer Docs Actions
        [GetInstallerDocs.pending]: (state) => {
            state.isLodaing = true;
        },
        [GetInstallerDocs.fulfilled]: (state, action) => {
            state.docs = action.payload;
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [GetInstallerDocs.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Installer Adders Actions
        [GetInstallerAdders.pending]: (state) => {
            state.isLodaing = true;
        },
        [GetInstallerAdders.fulfilled]: (state, action) => {
            state.adders = action.payload;
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [GetInstallerAdders.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Installer Adders Actions
        [GetInstallerLicense.pending]: (state) => {
            state.isLodaing = true;
        },
        [GetInstallerLicense.fulfilled]: (state, action) => {
            state.license = action.payload;
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [GetInstallerLicense.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Create Installer License
        [InstallerLicenseCreate.pending]: (state) => {
            state.isLodaing = true;
        },
        [InstallerLicenseCreate.fulfilled]: (state) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [InstallerLicenseCreate.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Edit Installer License
        [InstallerLicenseEdit.pending]: (state) => {
            state.isLodaing = true;
        },
        [InstallerLicenseEdit.fulfilled]: (state) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [InstallerLicenseEdit.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Edit Installer License
        [GetSingleInstaller.pending]: (state) => {
            state.isLodaing = true;
        },
        [GetSingleInstaller.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
            state.installer = action.payload ;
        },
        [GetSingleInstaller.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Edit Installer License
        [GetSingleInstallerLicense.pending]: (state) => {
            state.isLodaing = true;
        },
        [GetSingleInstallerLicense.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
            state.single_license = action.payload;
        },
        [GetSingleInstallerLicense.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Delete Single Installer 
        [DeleteSingleInstaller.pending]: (state) => {
            state.isLodaing = true;
        },
        [DeleteSingleInstaller.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
        },
        [DeleteSingleInstaller.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.errors = action.payload;
        },
    },
});

export const { reset } = installerSlice.actions;
export default installerSlice.reducer;
